module.exports = __webpack_public_path__ + "img/ic_favorite_device.f398ea38.svg";